import React from 'react';
import TextField from 'components/Form/FormTextField';
import Form from 'components/Form/Layout';
import * as yup from 'yup';
import validateForm from 'utils/Validator';
import LinkInvitationFooter from '../Footer';

type LinkInvitationStepProps = {
  onNext: ( values:any ) => void
  onPrevious: () => void
};

function LinkInvitationStep0( { onNext, onPrevious }: LinkInvitationStepProps ) {
  const validationSchema = yup.object( {
    code: yup.string().required()
      .min( 2, 'El código debe tener al menos 2 caracteres' ),
  } );
  const validate = validateForm( validationSchema );

  return (
    <Form
      validate={validate}
      onSubmit={( values ) => {
        onNext( values );
      }}
      body={( form ) => (
        <>
          <h2 className="text--black4">Introduce el código de validación</h2>

          <p className="text--gray20 mt-4 pt-2">
            Hemos enviado un código a su correo electrónico con un código de
            seguridad de 2 dígitos que tiene que introducir aquí
          </p>
          <div className="mt-4">
            <TextField
              field="code"
              label="Código"
            />
          </div>

          <LinkInvitationFooter
            onNext={form.submit}
            onPrevious={onPrevious}
            previousText="Solicitar nuevo código"
            showPrevIcon={false}
          />
        </>
      )}
    />
  );
}

export default LinkInvitationStep0;
